module.exports = __webpack_public_path__ + "static/media/android.0eaf4a80.svg";